import { Component, AfterViewChecked, OnInit, inject } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { UtenteDto } from 'app/domain/UtenteDto';
import { Router, RouterLink } from '@angular/router';
import { RivenditoreService } from 'app/services/rivenditore.service';
import { NgbCollapse, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    imports: [RouterLink, NgbCollapse, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu]
})

export class NavbarComponent implements OnInit, AfterViewChecked {
    private authService = inject(AuthService);
    private rivenditoreService = inject(RivenditoreService);
    private router = inject(Router);

    toggleClass = 'ft-maximize';
    placement = 'bottom-right'
    public isCollapsed = true;
    user: UtenteDto;
    logoRivenditore: string;

    ngOnInit(): void {
        this.user = this.authService.getUser();
        this.logoRivenditore = this.rivenditoreService.getLogoUrl(this.user.Licenza.IdRivenditore);
    }

    ngAfterViewChecked() {

        // setTimeout(() => {
        //     const wrapperDiv = document.getElementsByClassName('wrapper')[0];
        //     const dir = wrapperDiv.getAttribute('dir');
        //     if (dir === 'rtl') {
        //         this.placement = 'bottom-left';
        //     } else if (dir === 'ltr') {
        //         this.placement = 'bottom-right';
        //     }
        // }, 3000);


    }

    ToggleClass() {
        if (this.toggleClass === 'ft-maximize') {
            this.toggleClass = 'ft-minimize';
        } else {
            this.toggleClass = 'ft-maximize'
        }
    }

    logout() {
        this.authService.logout();
        this.router.navigate(['login']);
    }
}
